import { useEffect } from 'react';

const useFptiImpression = (ref, action) => {
  useEffect(() => {
    const listener = () => {
      const checkWidgetInsideViewport = domEl => {
        if (!domEl) {
          return false;
        }
        const { left, bottom, right } = domEl.getBoundingClientRect();
        return (
          left >= 0 &&
          bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          right <= (window.innerWidth || document.documentElement.clientWidth)
        );
      };

      if (checkWidgetInsideViewport(ref.current)) {
        action();
        document.removeEventListener('scroll', listener);
      }
    };
    document.addEventListener('scroll', listener);

    return () => document.removeEventListener('scroll', listener);
  }, []);
};

export { useFptiImpression };
